import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";

const liff = window.liff;

export const CloseLbcRedirect = () => {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const closeLiffWindow = () => {
            if (liff) {
                liff.closeWindow();
            } else {
                setLoading(false);
                window.location.href = "/";
            }
        };
        closeLiffWindow();
    }, []);

    return (
        <div>
            <LoadingOverlay
                text="Loading"
                spinner
                active={loading}
                styles={{ wrapper: { width: '100%', minHeight: '100%' } }}
            /></div>
    );
};

export default CloseLbcRedirect;
